const isProd = process.env.NODE_ENV === 'production';
const localRoot = () => typeof window !== 'undefined' && window.location.pathname.startsWith('/orderpro/') ? '/orderpro' : '';

export const apiConstants = {
    get baseURL() { return `${window.location.origin}${isProd ? localRoot() : ''}/api_qr_order/`; },
    get translationCatalogURL() { return `${window.location.origin}${isProd ? localRoot() : ''}/api_common/ui_translation.php`; },
};

export const pageConstants = {
    get subFolder() {
        const root = localRoot();
        const source = typeof window !== 'undefined' && window.location.pathname.slice(root.length).match(/^\/(qr|nfc)(?:\/|$)/);
        if (source) {
            return `${root}/${source[1]}`;
        }
        return root;
    }
};
